import { callApi } from "./fetchTools";
import { HTTP_METHOD_GET } from "../utils/constant";
import apis from "../common/apis";
import {
  IEventImageModel,
  IEventImageListParams,
  IEventImageDetailModel,
} from "../models/interface";
import { IResponse } from "../models";

export default {
  getEventImages: (params?: IEventImageListParams) => {
    return callApi<IResponse<Record<number, IEventImageModel[]>>>(
      HTTP_METHOD_GET,
      apis.event_images,
      params
    );
  },
  getEventImage: (eventId: string) => {
    return callApi<IEventImageModel>(
      HTTP_METHOD_GET,
      apis.event_image.replace(":id", eventId),
      null
    );
  },
  getEventImageDetailsForHomePage: (params?: { limit?: number }) => {
    return callApi<IEventImageDetailModel[]>(
      HTTP_METHOD_GET,
      apis.event_image_details_home_page,
      params
    );
  },
};
